module.exports = __webpack_public_path__ + "img/1929-35 - Charles Houston.e4e27ad2.jpg";